import { createContext } from "solid-js"
import type { ScenarioStore } from "./types"

/**
 * Context for ScenarioStore
 * Provides reactive access to scenario data throughout the component tree
 */
export const ScenarioContext = createContext<ScenarioStore>()
